import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../constants";
import { FormKeys } from "../helpers";
import { FormSectionComponent } from "./FormSectionComponent";

export const CreateHrTaskWhenAccepted = () => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED || status === WORK_AGREEMENT_DECLINED;

  const rows = [
    {
      title: "",
      component: (
        <Controller
          control={control}
          name={FormKeys.CreateHrTaskWhenTalentAcceptsAgreement}
          render={({ field: { name, value, onChange } }) => (
            <FormControlLabel
              disabled={isReadOnly}
              control={
                <Checkbox
                  name={name}
                  checked={!!value}
                  onChange={(event) => onChange(event.target.checked)}
                />
              }
              label={t("order:createHrTaskWhenTalentAcceptsAgreement")}
            />
          )}
        />
      ),
    },
  ];

  return <FormSectionComponent rows={rows} />;
};
